
import Blog from '~/components/Common/Blog/'
import BlogHtmlFile from '~/components/Common/Blog/BlogHtmlFile'

export default {
    components: {
        // Board
        Blog,
        BlogHtmlFile,
    },
}
